import React, { useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import useAuthenticationLog from "../../../hooks/useAuthenticationLog";
import useAuth from "../../../hooks/useAuth";
import ProCard from "./ProCard";
import ProLineChart from "./ProLineChart";

function AuthorizationsChart() {
  const { getAuthStats, authenticationLogStats } = useAuthenticationLog();
  const { user } = useAuth();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (user && !hasFetched.current) {
      getAuthStats();
      hasFetched.current = true;
    }
  }, [user]);

  const authChartLabels =
    authenticationLogStats?.length > 0
      ? authenticationLogStats.map((d) => {
          const date = new Date(d.createdAt);
          return `${String(date.getHours()).padStart(2, "0")}:00`;
        })
      : ["07:00", "12:00", "17:00", "22:00", "03:00", "08:00", "13:00"];

  const authChartData =
    authenticationLogStats?.length > 0
      ? authenticationLogStats.map((d) => d.count || 0)
      : [0, 0, 0, 0, 0, 0, 0];

  return (
    <Grid item xs={12} md={6}>
      <ProCard title="Authorizations (24h)">
        <ProLineChart data={authChartData} labels={authChartLabels} />
      </ProCard>
    </Grid>
  );
}

export default AuthorizationsChart;
